import { ErrorResponseSchema } from '@cookspace-shared-contracts/core';

/**
 * Generic-сообщения по кодам ошибок дерева типов меню (контракт
 * AdminMenuItemTypes + admin-backend, MF-11): показываем понятный
 * человеку текст, не раскрывая технических деталей структуры дерева.
 *
 * `MENU_ITEM_TYPE_REORDER_WRONG_PARENT` — код admin-backend (#003),
 * в JSDoc контракта не задокументирован; остальные коды могут добавляться
 * на сервере — незнакомый код падает в fallback.
 */
const ERROR_MESSAGES: Record<string, string> = {
    MENU_ITEM_TYPE_NOT_FOUND: 'Узел не найден',
    MENU_ITEM_TYPE_CYCLE_DETECTED: 'Нельзя переместить узел внутрь его потомка',
    MENU_ITEM_TYPE_DEPTH_EXCEEDED: 'Превышена максимальная глубина дерева',
    MENU_ITEM_TYPE_SLUG_TAKEN: 'Узел с таким slug уже существует',
    MENU_ITEM_TYPE_IN_USE:
        'Узел используется группами кафе или имеет активные дочерние узлы',
    MENU_ITEM_TYPE_REORDER_WRONG_PARENT:
        'Не удалось изменить порядок — обновите страницу и попробуйте снова'
};

/**
 * Достаёт `error.data.error.code` из ошибки RTK Query (`FetchBaseQueryError`
 * формы `{ status, data }`) и возвращает generic-сообщение по коду.
 * Любая незнакомая/непарсибельная форма → fallback.
 */
export function getMenuItemTypeErrorMessage(error: unknown, fallback: string): string {
    if (typeof error !== 'object' || error === null || !('data' in error)) {
        return fallback;
    }
    const parsed = ErrorResponseSchema.safeParse((error as { data?: unknown }).data);
    if (!parsed.success) {
        return fallback;
    }
    return ERROR_MESSAGES[parsed.data.error.code] ?? fallback;
}
